import {alpha, Box, CircularProgress, Typography} from "@mui/material";

type LoadingOverlayProps = {
  message?: string;
  subtle?: boolean;
};

export const LoadingOverlay = ({
  message = "Carregando…",
  subtle,
}: LoadingOverlayProps) => (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      zIndex: (t) => t.zIndex.modal - 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 2,
      bgcolor: (t) =>
        subtle
          ? alpha(t.palette.background.paper, 0.85)
          : alpha(t.palette.grey[900], 0.35),
      backdropFilter: subtle ? "blur(6px)" : "blur(4px)",
    }}
  >
    <CircularProgress size={subtle ? 40 : 48} thickness={4} />
    {message ? (
      <Typography variant="body2" color={subtle ? "text.secondary" : "common.white"}>
        {message}
      </Typography>
    ) : null}
  </Box>
);
